import axios from 'axios';

const api = axios.create({
    withCredentials: true,
    baseURL: '/api/cognitive-flows',
});

/**
 * Point API at the ScaleX backend (e.g. http://localhost:9000/api/cognitive-flows).
 */
export function setCognitiveFlowsApiBase(appUrl) {
    const base = String(appUrl || '').replace(/\/$/, '');
    api.defaults.baseURL = `${base}/api/cognitive-flows`;
}

// Selected workspace scope. Every CF request carries it as the x-cf-workspace
// header ('account' = account level); the server validates access per request.
let currentWorkspaceId = null;

export function setCognitiveFlowsWorkspace(workspaceId) {
    currentWorkspaceId = workspaceId || null;
}

/** For raw fetch() calls (SSE streams) that bypass the axios interceptor. */
export function getCognitiveFlowsWorkspace() {
    return currentWorkspaceId || 'account';
}

api.interceptors.request.use((config) => {
    // A caller that set the header ITSELF is targeting a specific workspace
    // rather than the selected one — the workspace form edits a workspace from
    // a list, which is often not the one currently in scope, and silently
    // rewriting it here would save the wrong workspace's settings under the
    // right workspace's name. The server still validates the id against this
    // account (resolveWorkspace), so an explicit value is no less safe.
    if (!config.headers['x-cf-workspace']) {
        config.headers['x-cf-workspace'] = currentWorkspaceId || 'account';
    }
    return config;
});

api.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err.response?.status === 401) {
            window.location.href = '/login';
        }
        return Promise.reject(err);
    }
);

export default api;
